export const colors = {
  healthy: '#b5b9ba',
  healthyArea: '#dee1e3',
  sick: '#df1a22',
  cured: '#00a4e2'
};
